import { render, staticRenderFns } from "./MainWebsite.vue?vue&type=template&id=00f51ef6"
import script from "./MainWebsite.vue?vue&type=script&lang=js"
export * from "./MainWebsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports